import { render, staticRenderFns } from "./score-stats.vue?vue&type=template&id=22a2df30&scoped=true"
import script from "./score-stats.vue?vue&type=script&lang=js"
export * from "./score-stats.vue?vue&type=script&lang=js"
import style0 from "./score-stats.vue?vue&type=style&index=0&id=22a2df30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2df30",
  null
  
)

export default component.exports